import { getPagesBySlug } from '../services/reservoir'
import { getReservoirApiUrl } from '../services/vu'
import { forEach } from 'lodash/collection'

export const fetchPage = pathname => {
  return (dispatch, getState) => {
    dispatch(requestPage(pathname))

    const {
      courses: { selectedCourseCode, data }
    } = getState()
    const { admissionCategory } = selectedCourseCode

    return getPagesBySlug(getPageSlug(pathname), admissionCategory).then(({ data = [], included = [] }) => {
      if (data.length > 0) {
        const page = data[0]

        const title = page.attributes && page.attributes.title

        const backgroundImageMeta = page.relationships.field_background_image
        if (backgroundImageMeta.data.length > 0) {
          const backgroundImage = included.find(includes => includes.id === backgroundImageMeta.data[0].id)
          if (!!backgroundImage) {
            return getReservoirApiUrl(backgroundImage.attributes.uri.url).then(backgroundImageUrl => {
              return dispatch(receivePage(pathname, title, backgroundImageUrl))
            })
          }
        }

        return dispatch(receivePage(pathname, title, null))
      } else {
        return dispatch(receivePage(pathname, '', null))
      }
    })
  }
}

const requestPage = pathname => {
  return {
    type: 'REQUEST_PAGE',
    slug: getPageSlug(pathname),
    pathname
  }
}

const receivePage = (pathname, title, backgroundImage) => {
  return {
    type: 'RECEIVE_PAGE',
    slug: getPageSlug(pathname),
    pathname,
    title,
    backgroundImage
  }
}

const getPageSlug = pathname => {
  const urlPath = pathname.replace(/^\/?myvu\/?/, '').replace(/^\//, '')
  let slug = 'home'

  if (urlPath !== '') {
    if (urlPath.startsWith('reports/')) {
      slug = urlPath.replace('/', '_')
    } else if (urlPath.split('/').length > 0) {
      slug = urlPath.split('/')[0]
    } else {
      slug = urlPath
    }
  }

  return slug
}
